import React from "react";
import {Nav, Navbar, NavbarBrand, NavItem} from "reactstrap";
import {withRouter} from "react-router-dom";
import securityService from "../services/securityService";


class AppNavBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    logout = (event) => {
        event.preventDefault();
        localStorage.clear();
        sessionStorage.clear();
        this.props.history.push("/");
    }

    showCRMorLogout = () => {

        if (securityService.hasAnyRole(["ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_ADMIN", "ROLE_LEVEL1",
            "ROLE_LEVEL2", "ROLE_LEVEL3"])) {
            return (<span
                color="default"
                className="mb-3 xgnav-link"
                style={{cursor: "pointer"}}
                onClick={(event) => {
                    event.preventDefault();
                    this.props.history.push("/admin/dashboard"); // Navigate to CRM if logged in
                }}
            >
                        Switch to CRM
                      </span>)
        } else if(securityService.hasAnyRole([ "ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"])){
            return (<span
                color="default"
                className="mb-3 xgnav-link"
                style={{cursor: "pointer"}}
                onClick={(event) => {
                    event.preventDefault();
                    this.props.history.push("/user/dashboard"); // Navigate to CRM if logged in
                }}
            >
                        Switch to Dashboard
                      </span>)
        } else if (securityService.hasAnyRole(["ROLE_STARTER"])) {
            return (<span
                color="default"
                className="mb-3 xgnav-link"
                style={{cursor: "pointer"}}
                onClick={(event) => {
                    event.preventDefault();
                    this.logout(event);
                }}
            >
                        Logout
                      </span>)
        }
    }

    render() {
        return (
            <Navbar color="white" light expand="md">
                <NavbarBrand href="/"><img height={"auto"} width={"170px"} alt={"XareGrowth"}
                                           src={require("assets/img/brand/xareLogo_transparent.png")}/></NavbarBrand>
                <Nav className="ml-auto" navbar={true} style={{zIndex: "10000"}}>
                <NavItem>
                            <span color="default" className="mb-3 xgnav-link"
                                  onClick={(event) => {
                                      event.preventDefault();
                                      this.props.history.push("/aboutUs");
                                  }}
                            >About Us</span>&nbsp;&nbsp;&nbsp;
                        <span color="default" className="mb-3 xgnav-link"
                              onClick={(event) => {
                                  event.preventDefault();
                                  this.props.history.push("/");
                              }}
                        >Services</span>&nbsp;&nbsp;&nbsp;
                        <span color="default" className="mb-3 xgnav-link"
                              onClick={(event) => {
                                  event.preventDefault();
                                  this.props.history.push("/knowledgeCentre");
                              }}
                        >
                  Knowledge
                </span>&nbsp;&nbsp;&nbsp;
                    <span color="default" className="mb-3 xgnav-link"
                          onClick={(event) => {
                              event.preventDefault();
                              this.props.history.push("/xareview");
                          }}
                    >
                  Reviews
                </span>&nbsp;&nbsp;&nbsp;
                        <span color="default" className="mb-3 xgnav-link"
                              onClick={(event) => {
                                  event.preventDefault();
                                  this.props.history.push("/pricing");
                              }}
                        >
                  Pricing
                </span>&nbsp;&nbsp;&nbsp;
                        <>
                            {localStorage.getItem("userId") ? this.showCRMorLogout(): (<span
                                color="default"
                                className="mb-3 xgnav-link"
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.props.loginModalToggle("loginModal")
                                }}
                            >
                        Login
                      </span>)}
                        </>
                    </NavItem>
                </Nav>
            </Navbar>
        )
    }
}

export default withRouter(AppNavBar);